(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("tiff-tiles", [], factory);
	else if(typeof exports === 'object')
		exports["tiff-tiles"] = factory();
	else
		root["tiff-tiles"] = factory();
})(self, function() {
return 